module.exports = {"530424001":"宁州街道","530424102":"盘溪镇","530424103":"华溪镇","530424104":"青龙镇","530424201":"通红甸彝族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530424.json
// module id = 2703
// module chunks = 0